/** A Client's onboarding status as a small uppercase badge. */

import type { ClientTenantStatus } from '@bluesphere/api-client';

const STYLES: Record<ClientTenantStatus, { label: string; classes: string }> = {
  pending: { label: 'Pending consent', classes: 'bg-amber-100 text-amber-800 border-amber-300' },
  consented: {
    label: 'Connected',
    classes: 'bg-emerald-100 text-emerald-800 border-emerald-300',
  },
  active: {
    label: 'Active',
    classes: 'bg-emerald-100 text-emerald-800 border-emerald-300',
  },
  revoked: {
    label: 'Revoked',
    classes:
      'bg-bluesphere-surfaceMuted text-bluesphere-textSecondary border-bluesphere-borderMuted',
  },
};

export function StatusBadge({ status }: { status: ClientTenantStatus }) {
  const s = STYLES[status];
  return (
    <span
      className={`rounded-sm border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider ${s.classes}`}
    >
      {s.label}
    </span>
  );
}

/**
 * The same badge shape for a per-integration connection state, which is
 * a different vocabulary from the Client's onboarding status.
 */
export type ConnectionState = 'connected' | 'pending' | 'not_connected' | 'removed' | 'revoked';

const CONNECTION_STYLES: Record<ConnectionState, { label: string; classes: string }> = {
  connected: STYLES.consented,
  pending: STYLES.pending,
  not_connected: {
    label: 'Not connected',
    classes: 'bg-white text-bluesphere-textSecondary border-bluesphere-borderMuted',
  },
  removed: {
    label: 'Removed',
    classes:
      'bg-bluesphere-surfaceMuted text-bluesphere-textSecondary border-bluesphere-borderMuted',
  },
  revoked: STYLES.revoked,
};

export function ConnectionBadge({ state }: { state: ConnectionState }) {
  const s = CONNECTION_STYLES[state];
  return (
    <span
      className={`rounded-sm border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider ${s.classes}`}
    >
      {s.label}
    </span>
  );
}
